import React from "react";
import { wait } from "../utils/mock";
import AutoComplete from "../components/Autocomplete";

const fetchProjectOptions = async ({ filter }) => {
    await wait(650);
    return [...Array(10).keys()].map((id) => ({ id, name: `Projekt ${id}` }));
};

export const ProjectSelect = ({ value, onChange, fullWidth = true, ...props }) => {
    //autoSelect
    return (
        <AutoComplete
            fullWidth={fullWidth}
            {...props}
            fetchOptions={fetchProjectOptions}
            getOptionLabel={(option) => option.name}
            value={value || null}
            onChange={(e, val) => {
                if (typeof val === "string") {
                    val = { name: val };
                }
                onChange && onChange(val);
            }}
            onBlur={(e) => {
                if (!value || !value.id) {
                    onChange && onChange(e.target.value ? { name: e.target.value } : null);
                }
            }}
            freeSolo
            clearable
        />
    );
};
